<script setup>
import { ref, onMounted } from "vue";
import { getApiBaseUrl } from "./ApiBaseUrl.js";

const props = defineProps({
  modelValue: { type: String, default: "" },
});
const emit = defineEmits(["update:modelValue"]);

const API_BASE = getApiBaseUrl();

const options = ref([]);
const loading = ref(false);
const error = ref("");

async function load() {
  loading.value = true;
  error.value = "";
  try {
    const res = await fetch(`${API_BASE}/api/districts`);
    if (!res.ok) throw new Error("network");
    const data = await res.json();
    options.value = Array.isArray(data.districts) ? data.districts : [];
    if (!props.modelValue && options.value.length) {
      emit("update:modelValue", options.value[0]);
    }
  } catch (e) {
    error.value = "목록을 불러오지 못했습니다.";
    options.value = [];
  } finally {
    loading.value = false;
  }
}

onMounted(load);
</script>

<template>
  <div class="region-combo">
    <select
      id="regionCombo"
      :value="modelValue"
      @change="(e) => $emit('update:modelValue', e.target.value)"
    >
      <option value="000" selected>선택하세요</option>
      <option v-for="o in options" :key="o" :value="o">{{ o }}</option>
    </select>
    <span v-if="loading" class="muted">로딩...</span>
    <span v-if="error" class="error">{{ error }}</span>
  </div>
</template>

<style scoped>
.region-combo {
  display: flex;
  gap: 8px;
  align-items: center;
}
select {
  padding: 8px 10px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(0, 0, 0, 0.16);
  color: #ffffff;
}
/* Attempt to style dropdown options separately. Note: native select styling is limited by browser/OS. */
select option {
  color: #111827; /* darker text for options when dropdown opens */
  background: #ffffff;
}
select option:checked,
select option[selected] {
  color: #ffffff; /* selected option in list (may be ignored by some browsers) */
  background: #0b67ff;
}
.muted {
  opacity: 0.8;
  font-size: 12px;
}
.error {
  color: #ffb3b3;
  font-size: 12px;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .region-combo {
    width: 100%;
    gap: 6px;
  }

  select {
    flex: 1;
    padding: 10px;
    min-height: 44px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  select {
    width: 100%;
    min-height: 44px;
    padding: 10px;
    font-size: 16px;
  }

  .muted {
    font-size: 11px;
  }

  .error {
    font-size: 11px;
  }
}
</style>
